// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b01576cb","239":"6946d186","455":"ada17d99"}[chunkId] + ".chunk.js";
};